// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}
.data-overview {
  display: flex;
  justify-content: center;
  padding: 20px;
}

.data-card {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  max-width: 800px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  background-color: #fff;
}

.data-table {
  font-size: 11px;
  width: 100%;
  border-collapse: collapse;
}

.data-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.data-table .field-title {
  color: #777; /* Slightly grey color for field titles */
  width: 30%; /* Ensure the titles have a consistent width */
}

.data-table .field-value {
  width: 70%; /* Ensure the values have a consistent width */
}

.data-table img {
  max-width: 400px;
  max-height: 400px;
  width: 100%;
  height: auto;
  border-radius: 4px;
  display: block;
  margin: 0;
}

.data-table tr:nth-child(even) {
  background-color: #f2f2f2;
}

.data-table tr:hover {
  background-color: #ddd;
}

.data-table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #4CAF50;
  color: white;
}

.data-table td[colspan="2"] {
  text-align: center;
  background-color: #f9f9f9;
  font-weight: bold;
}


@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW,EAAE,yCAAyC;EACtD,UAAU,EAAE,8CAA8C;AAC5D;;AAEA;EACE,UAAU,EAAE,8CAA8C;AAC5D;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;;AAGA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n.data-overview {\n  display: flex;\n  justify-content: center;\n  padding: 20px;\n}\n\n.data-card {\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 16px;\n  width: 100%;\n  max-width: 800px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  background-color: #fff;\n}\n\n.data-table {\n  font-size: 11px;\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.data-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n}\n\n.data-table .field-title {\n  color: #777; /* Slightly grey color for field titles */\n  width: 30%; /* Ensure the titles have a consistent width */\n}\n\n.data-table .field-value {\n  width: 70%; /* Ensure the values have a consistent width */\n}\n\n.data-table img {\n  max-width: 400px;\n  max-height: 400px;\n  width: 100%;\n  height: auto;\n  border-radius: 4px;\n  display: block;\n  margin: 0;\n}\n\n.data-table tr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n\n.data-table tr:hover {\n  background-color: #ddd;\n}\n\n.data-table th {\n  padding-top: 12px;\n  padding-bottom: 12px;\n  text-align: left;\n  background-color: #4CAF50;\n  color: white;\n}\n\n.data-table td[colspan=\"2\"] {\n  text-align: center;\n  background-color: #f9f9f9;\n  font-weight: bold;\n}\n\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
